import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Input,
  Button,
  Typography,
  Divider,
  Modal,
  Popconfirm,
  Form,
  Select,
} from "antd";

import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";
// import {
//   ChangeTrainerSearchText,
//   ChangeStudentTableData,
//   ChangeTrainerModalState,
// } from "../../../actions/adminAction";
import { changeTrainerSearchText } from "../../../reducers/admin";
import "../allStudent/allstudent.css";
import "./AllRewards.css";
import Diamond from "../../../assets/diamond.svg";

import Alert from "../../../components/common/alert";
import {
  SecureDelete,
  SecurePost,
  SecurePostMultipart,
} from "../../../services/axiosCall";
import apis, { IMGAE_BASE_URL } from "../../../services/Apis";
import UploadIcon from "../../../assets/fileUpload.svg";
import CrossIcon from "../../../assets/crossIcon.svg";
import {
  fetchAllCategories,
  fetchAllRewards,
} from "../../../features/adminAsync";
import {
  DeleteOutlined,
  InfoCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
// import { fetchStudentTableData } from "../../../features/adminAsync";

const initialValue = {
  name: "",
  description: "",
  cost: "",
  categoryId: "",
};

const AllRewards = () => {
  const dispatch = useDispatch();
  // const { TrainersearchText } = useSelector((state) => state.admin);
  const { category } = useSelector((state) => state.category);
  //  console.log(category);

  const { loading, rewards } = useSelector((state) => state.rewards);
  // console.log(rewards);

  // const searchInputRef = useRef(null);
  const [isCategory, setIsCategory] = useState(false);
  const [isRewardInfo, setIsRewardInfo] = useState(false);
  const [rewardObject, setRewardObject] = useState();
  const [isReward, setIsReward] = useState(false);
  const [image, setImage] = useState(null);
  const [category1, setCategory1] = useState("");
  const [reFectch, setRefetch] = useState(false);
  const [rewardValue, setRewardValue] = useState(initialValue);
  const [reFectchRewards, setRefetchRewards] = useState(false);

  const handleImageChage = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      if (selectedFile.type.startsWith("image/")) {
        setImage(selectedFile);
      } else {
        Alert("warning", "message", "Please select a valid image file.");
      }
    }
  };

  const handleChangeReward = (e) => {
    const { name, value } = e.target;
    setRewardValue({
      ...rewardValue,
      [name]: value,
    });
  };

  // const handleAproved = async (id) => {
  //   try {
  //     const res = await SecurePost({
  //       url: `${apis.APROVE_STUDENT}`,
  //       data: {
  //         studentId: id,
  //       },
  //     });

  //     if (res) {
  //       dispatch(changeStudentTableLoadingStatus());
  //     }
  //   } catch (error) {}
  // };

  const deleteRewards = (id) => {
    SecureDelete({
      url: `${apis.DELETE_REWARD}/${id}`,
    })
      .then((response) => {
        if (response.data.message) {
          Alert("success", "Success", response?.data?.message);
          setRefetchRewards(!reFectchRewards);
        } else {
          return Alert("warning", "Warning!", response?.data?.message);
        }
      })
      .catch((error) => {
        const message = error.response
          ? error.response.data.message
          : error.message;
        return Alert("error", "Error!", message);
      });
  };

  const handleCreateCategory = () => {
    if (category1 === "") {
      return Alert("warning", "Warning!", "Please write any category Name");
    }
    SecurePost({
      url: `${apis.CREATE_CATEGORY}`,
      data: {
        name: category1,
      },
    })
      .then((response) => {
        if (response.data.success) {
          Alert("success", "Success", response.data.message);
          setRewardValue(initialValue);
          setRefetch(!reFectch);
          setIsCategory(false);
        } else {
          return Alert("warning", "Warning!", response.data.message);
        }
      })
      .catch((error) => {
        const message = error.response
          ? error.response.data.message
          : error.message;
        return Alert("error", "Error!", message);
      });
  };

  useEffect(() => {
    dispatch(fetchAllCategories());
  }, [reFectch,dispatch]);

  useEffect(() => {
    dispatch(fetchAllRewards());
  }, [,reFectch,dispatch]);

  // const getColumnSearchProps = (dataIndex) => ({
  //   filterDropdown: ({
  //     setSelectedKeys,
  //     selectedKeys,
  //     confirm,
  //     clearFilters,
  //   }) => (
  //     <div style={{ padding: 8 }}>
  //       <Input
  //         ref={(node) => {
  //           searchInputRef.current = node;
  //         }}
  //         placeholder={`Search ${dataIndex}`}
  //         value={selectedKeys[0]}
  //         onChange={(e) =>
  //           setSelectedKeys(e.target.value ? [e.target.value] : [])
  //         }
  //         onPressEnter={() => handleSearch(selectedKeys, confirm)}
  //         style={{ width: 188, marginBottom: 8, display: "block" }}
  //       />
  //       <Button
  //         type="primary"
  //         onClick={() => handleSearch(selectedKeys, confirm)}
  //         icon="search"
  //         size="small"
  //         style={{ width: 90, marginRight: 8 }}
  //       >
  //         Search
  //       </Button>
  //       <Button
  //         onClick={() => handleReset(clearFilters)}
  //         size="small"
  //         style={{ width: 90 }}
  //       >
  //         Reset
  //       </Button>
  //     </div>
  //   ),
  //   filterIcon: (filtered) => (
  //     <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
  //   ),
  //   onFilter: (value, record) =>
  //     record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
  //   onFilterDropdownVisibleChange: (visible) => {
  //     if (visible) {
  //       setTimeout(() => searchInputRef.current.select());
  //     }
  //   },
  //   render: (text) => (
  //     <Highlighter
  //       highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
  //       searchWords={[TrainersearchText]}
  //       autoEscape
  //       textToHighlight={text?.toString()}
  //     />
  //   ),
  // });

  const handleCreateReward = () => {
    if (rewardValue.name === "") {
      return Alert("warning", "Warning!", "Name is required");
    }
    if (rewardValue.description === "") {
      return Alert("warning", "Warning!", "Description is required");
    }
    if (rewardValue?.categoryId === "") {
      return Alert("warning", "Warning!", "Category is required");
    }
    if (rewardValue.cost === "") {
      return Alert("warning", "Warning!", "Cost is required");
    }
    if (!image) {
      return Alert("warning", "Warning!", "Image is required");
    }

    const formData = new FormData();
    formData.append("name", rewardValue.name);
    formData.append("description", rewardValue.description);
    formData.append("categoryId", rewardValue.categoryId);
    formData.append("cost", rewardValue.cost);
    formData.append("image", image);

    SecurePostMultipart({
      url: `${apis.CREATE_REWARD}`,
      data: formData,
    })
      .then((response) => {
        if (response.data.success) {
          Alert("success", "Success", response.data.message);
          setRefetchRewards(!reFectchRewards);
          setIsReward(false);
        } else {
          return Alert("warning", "Warning!", response.data.message);
        }
      })
      .catch((error) => {
        const message = error.response
          ? error.response.data.message
          : error.message;
        return Alert("error", "Error!", message);
      });
  };

  // const handleSearch = (selectedKeys, confirm) => {
  //   confirm();
  //   dispatch(changeTrainerSearchText(selectedKeys[0]));
  // };

  // const handleReset = (clearFilters) => {
  //   clearFilters();
  //   dispatch(changeTrainerSearchText(""));
  // };

  // useEffect(() => {
  //   dispatch(fetchStudentTableData());
  // }, [dispatch]);

  const { Title } = Typography;
  const columns = [
    { 
      title: <span style={{ color: "black" }}>Name</span>,
      dataIndex: "name",
      key: "name",
      width: "25%",
      render: (text) => <span style={{color:"black"}}>{text}</span> || "N/A",
      // ...getColumnSearchProps("name"),
    },
    {
      title: <span style={{ color: "black" }}>Description</span>,
      dataIndex: "description",
      key: "description",
      width: "25%",
      render: (text) => <span style={{color:"black"}}>{text}</span> || "N/A",
      // ...getColumnSearchProps("description"),
    },
    {
      title: <span style={{ color: "black" }}>Category</span>,
      dataIndex: "categoryId",
      key: "categoryId",
      render: (_, record) => <span style={{color:"black"}}>{record?.categoryId?.name}</span> || "N/A",
      // ...getColumnSearchProps("categoryId"),
    },
    {
      title: <span style={{ color: "black" }}>Cost</span>,
      dataIndex: "cost",
      key: "cost",
      render: (text) => <span style={{color:"black"}}>{text}</span> || "N/A",
      // ...getColumnSearchProps("cost"),
    },
    {
      title: <span style={{ color: "black" }}>Action</span>,
      key: "action",
      dataIndex: "_id",
      render: (key, record) => (
        <span>
          <Button
            type="primary"
            shape="circle"
            icon={<InfoCircleOutlined />}
            onClick={() => {
              setIsRewardInfo(true);
              setRewardObject(record);
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Are you sure?"
            cancelText="No"
            okText="Yes"
            onConfirm={() => deleteRewards(key)}
          >
            <Button
              type="primary"
              danger
              shape="circle"
              icon={<DeleteOutlined />}
            />
          </Popconfirm>
        </span>
      ),
    },
  ];

  return (
    <>
      <div className="admin-table-container">
        <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Button
            type="primary"
            style={{ marginBottom: "10px", borderRadius: "30px" }}
            onClick={() => setIsCategory(true)}
          >
            Create Category
          </Button>
          <Button
            type="primary"
            style={{ marginBottom: "10px", borderRadius: "30px" }}
            onClick={() => setIsReward(true)}
          >
            Create Reward
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={rewards}
          pagination={{ pageSize: 10 }}
          loading={loading}
          rowKey="_id"
          style={{ backgroundColor: "#fff", padding: "10px" }}
        />
      </div>

      <Modal
        open={isCategory}
        footer={null}
        closable={false}
        onCancel={() => setIsCategory(false)}
        className="rewardMModalAdmin"
        width={450}
        style={{ top: "30%", borderRadius: "25px", backgroundColor: "#fff" }}
      >
        <div className="modal-content">
          <img
            src={CrossIcon}
            alt="Close"
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "10px",
              top: "10px",
            }}
            onClick={() => setIsCategory(false)}
          />
          <Typography className="cretaCateText">Create Category</Typography>
          <Typography style={{ marginTop: 3 }}>Name of category</Typography>
          <Input
            value={category1}
            className="ansInput"
            onChange={(e) => setCategory1(e.target.value)}
            style={{ marginBottom: "20px", marginTop: 5 }}
            required
          />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              style={{ width: "120px", borderRadius: "60PX" }}
              type="primary"
              onClick={handleCreateCategory}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={isReward}
        footer={null}
        closable={false}
        onCancel={() => setIsReward(false)}
        className="rewardMModalAdmin"
        width={525}
        style={{ top: "10%", borderRadius: "25px", backgroundColor: "#fff" }}
      >
        <div className="modal-content">
          <img
            src={CrossIcon}
            alt="Close"
            style={{
              cursor: "pointer",
              position: "absolute",
              right: "10px",
              top: "10px",
            }}
            onClick={() => setIsReward(false)}
          />
          <Typography className="cretaCateText">Create Reward</Typography>
          <Typography style={{marginTop:3}}>Name</Typography>
          <Input
            name="name"
            value={rewardValue.name}
            className="ansInput"
            style={{marginTop:3}}
            onChange={handleChangeReward}
            required
          />
          <Typography style={{marginTop:3}}>Description</Typography>
          <Input
            name="description"
            className="ansInput"
            style={{marginTop:3}}
            value={rewardValue.description}
            onChange={handleChangeReward}
            required
          />
          <Typography style={{marginTop:3}}>Category</Typography>
          <Select
            value={rewardValue.categoryId}
            className="ansInput"
            onChange={(value) =>
              setRewardValue({ ...rewardValue, categoryId: value })
            }
            placeholder="Select Level"
            style={{width:"100%",marginTop:3}}
            required
          >
            {category.map((d) => (
              <Select.Option key={d._id} value={d._id}>
                {d.name}
              </Select.Option>
            ))}
          </Select>
          <Typography style={{marginTop:3}}>Cost</Typography>
          <Input
            name="cost"
            value={rewardValue.cost}
            className="ansInput"
            style={{marginTop:3}}
            onChange={handleChangeReward}
            required
          />
          <label className="fileUpload" style={{marginTop:30}}>
            <img src={UploadIcon} alt="Upload"/>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChage}
              style={{ width: "0%"}}
            />
          </label>
          {image && <Typography>{image.name}</Typography>}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              style={{
                width: "120px",
                borderRadius: "60PX",
                marginTop: "20px",
              }}
              type="primary"
              onClick={handleCreateReward}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={isRewardInfo}
        footer={null}
        closable={false}
        onCancel={() => setIsRewardInfo(false)}
        className="rewardMModalAdmin"
        width={450}
        style={{ top: "30%", borderRadius: "25px", backgroundColor: "#fff" }}
      >
        <div className="reward_Card">
          {/* <img
            src={`{apis.BASE_LOCAL_URL}${rewardObject?.imgUrl}`}
            alt="Reward Image"
            width="60%"
            style={{ marginBottom: "20px" }}
          /> */}
          <Typography className="rewardTitle">{rewardObject?.name}</Typography>
          <Typography className="rewardDesc">
            {rewardObject?.description}
          </Typography>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Diamond} alt="Diamond" />
            <Typography className="rewardsPoints">
              {rewardObject?.cost} points
            </Typography>
          </div>
          <Button type="primary" onClick={() => setIsRewardInfo(false)}>
            Ok
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default AllRewards;
